
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'BaseDriver.vue',
  props: {
    item: {
      default() {
        return { ibutton: '' }
      }
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('persons', ['getPersons'])
  },
  methods: {
    emitInput(val) {
      if (this.uniqueIbuttonValidate(val))
        this.errors = 'El ibutton se encuentra en uso'
      else {
        this.errors = ''
      }
      this.$emit('ibuttonEmit', val)
    },
    uniqueIbuttonValidate(val) {
      return this.getPersons.some(person => person?.ibutton === val) && val != ''
    }
  },
  data() {
    return {
      driverRules: [
        v => v === '' || /^[0-9A-F]{8}$/g.test(v) || 'Identificador no valido'
      ],
      errors: ''
    }
  }
})
